<template>
  <div id="app">
    <v-app>
      <template v-if="$auth.ready()">
        <nprogress-container />
        <navbar :show="true" />
        <sidebar :show="sidebar.opened && !sidebar.hidden" />
        <app-main />
        <footer-bar />
        <delete-modal />
        <back-to-top text="Back To Top" />
      </template>
      <div v-else>
        <h1>Loading</h1>
      </div>
    </v-app>
  </div>
</template>

<script>
import * as Sentry from '@sentry/browser'
import NprogressContainer from 'vue-nprogress/src/NprogressContainer'
import { AppMain, FooterBar, Navbar, Sidebar } from 'components/layout/'
import DeleteModal from 'components/modals/DeleteModal'
import { mapActions, mapGetters } from 'vuex'
import BackToTop from 'vue-backtotop'

const userInclude = 'inventarisatie_user.app_clients.app_client_onderzoek_subscriptions.onderzoek,inventarisatie_user'

export default {
  components: {
    Navbar,
    Sidebar,
    AppMain,
    FooterBar,
    NprogressContainer,
    DeleteModal,
    BackToTop
  },
  computed: mapGetters({
    sidebar: 'sidebar'
  }),
  beforeMount () {
    const { body } = document
    const WIDTH = 768
    const RATIO = 3

    const handler = () => {
      if (!document.hidden) {
        const rect = body.getBoundingClientRect()
        const isMobile = rect.width - RATIO < WIDTH
        this.toggleDevice(isMobile ? 'mobile' : 'other')
        this.toggleSidebar({
          opened: !isMobile
        })
      }
    }

    this.GET_ACTIVE_USER({ params: { include: userInclude } }).then(({ data }) => {
      console.log('Welcome', data.name, `(uid: ${data.user_id})`)
      Sentry.setUser({ id: data.user_id, email: data.email })
    })

    document.addEventListener('visibilitychange', handler)
    window.addEventListener('DOMContentLoaded', handler)
    window.addEventListener('resize', handler)

    this.GET_ASSETS()
  },
  mounted () {
    // Interceptor to add variable translations to the translations if available
    this.$store.subscribe((mutation, state) => {
      // Check if mutation succeeded
      if (mutation.type.substr(-9) === 'SUCCEEDED') {
        //        Check payload
        if (mutation.payload?.data?.length) {
          const data = mutation.payload.data
          if (data[0]) {
            for (let i = 0; i < data.length; i++) {
              if (data[i].translated?.length) {
                for (const lan in data[i].translated) {
                  if (Object.prototype.hasOwnProperty.call(data[i].translated, lan)) {
                    const localeMessage = {}
                    localeMessage[data[i].value] = data[i].translated[lan].value
                    this.$i18n.mergeLocaleMessage(lan, localeMessage)
                  }
                }
              }
            }
          }
        }
      }
    })
  },
  methods: mapActions([
    'GET_ASSETS',
    'GET_ACTIVE_USER',
    'toggleDevice',
    'toggleSidebar'
  ])
}
</script>

<style lang="scss">
@import '~animate.css';
.animated {
  animation-duration: .377s;
}

@import '~bulma/bulma';

$fa-font-path: '~font-awesome/fonts/';
@import '~font-awesome/scss/font-awesome';

@import '~styles/bulma_kiwa.scss';
@import '~styles/variables.scss';
@import '~styles/app.scss';

html {
  background-color: whitesmoke;
}

.nprogress-container {
  position: fixed !important;
  width: 100%;
  height: 50px;
  z-index: 2048;
  pointer-events: none;

  #nprogress {
    $color: $brand-kiwa;

    .bar {
      background: $color;
      height: 5px;
    }
    .peg {
      box-shadow: 0 0 10px $color, 0 0 5px $color;
    }

    .spinner-icon {
      border-top-color: $color;
      border-left-color: $color;
    }
  }
}

  .ag-dnd-ghost-label {
    color: $text-color;
  }
</style>
